import { apiClient } from '@/sdk/shared/apiClient';
import type { RegisterRequest, RegisterResponse } from '../auth/types';
import type {
  GetLeadResponse,
  GetLeadsResponse,
  SearchTenantsResponse,
  SearchUsersResponse,
} from './types';

class LeadsApi {
  // Create a new client (formerly lead) with tenant_slug
  async createLead(data: RegisterRequest): Promise<RegisterResponse> {
    return apiClient.post<RegisterResponse>('/auth/register', data);
  }

  // Get lead by ID
  async getLeadById(id: string): Promise<GetLeadResponse> {
    return apiClient.get<GetLeadResponse>(`/leads/${id}`);
  }

  // Get leads by tenant slug
  async getLeadsByTenant(
    tenantSlug: string,
    limit?: number,
    offset?: number
  ): Promise<GetLeadsResponse> {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    if (offset) params.append('offset', offset.toString());
    
    const queryString = params.toString();
    const endpoint = `/leads/tenant/${tenantSlug}${queryString ? `?${queryString}` : ''}`;
    
    return apiClient.get<GetLeadsResponse>(endpoint);
  }

  // Search tenants by slug or name (for autocomplete)
  async searchTenants(query: string, limit?: number): Promise<SearchTenantsResponse> {
    const params = new URLSearchParams();
    params.append('q', query);
    if (limit) params.append('limit', limit.toString());
    
    return apiClient.get<SearchTenantsResponse>(`/tenants/search?${params.toString()}`);
  }

  // Search active users within a tenant by slug (for assigned user selection during registration)
  async searchUsersByTenant(tenantSlug: string, query: string, limit?: number): Promise<SearchUsersResponse> {
    const params = new URLSearchParams();
    params.append('q', query);
    if (limit) params.append('limit', limit.toString());
    
    return apiClient.get<SearchUsersResponse>(`/tenants/${tenantSlug}/users/search?${params.toString()}`);
  }
}

export const leadsApi = new LeadsApi();
